import { cn } from '~/lib/utils';

export function CardBox({
  className,
  children,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'overflow-hidden rounded-2xl border border-card-border bg-card-background p-5 shadow-card',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function InnerCard({
  title,
  className,
  children,
}: {
  title?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className="flex flex-col gap-2">
      {title && <h4 className="text-[14px]">{title}</h4>}
      <div
        className={cn(
          'border border-card-border bg-card-background rounded-2xl p-5 flex flex-col gap-4 shadow-card',
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}

function Card({
  children,
  className,
  outerClassName,
}: {
  children: React.ReactNode;
  className?: string;
  outerClassName?: string;
}) {
  return (
    <div
      className={cn(
        'border-1 border-nn-blue-400 rounded-lg p-2 bg-card-outer contents sm:block',
        outerClassName,
      )}
    >
      <div className={cn('sm:rounded-2xl sm:bg-card-inner sm:p-10 flex-row flex', className)}>
        {children}
      </div>
    </div>
  );
}

export default Card;
